import type { Service } from '@/services/firestore/types'
import { getPrintMenuImage } from '@/content/printMenu/imageMap'
import type { MenuPage } from '@/content/printMenu/types'

const GEL_SECTION = 'Gel Manicure'
const PED_SECTION = 'Pedicures'

function sortByDisplayOrder(services: Service[]) {
  return [...services].sort((a, b) => {
    if (a.displayOrder !== b.displayOrder) {
      return a.displayOrder - b.displayOrder
    }

    return a.name.localeCompare(b.name)
  })
}

export function buildMenuPages(catalog: Service[]): MenuPage[] {
  const pages: MenuPage[] = [{ kind: 'cover' }]
  const sorted = sortByDisplayOrder(catalog)
  const gelServices = sorted.filter((service) => service.category === 'gel')
  const pedicureServices = sorted.filter((service) => service.category === 'pedicure')

  pages.push({ kind: 'section', title: GEL_SECTION })
  for (const service of gelServices) {
    const imageKey = service.imageKey ?? service.id
    const { src, alt } = getPrintMenuImage(imageKey)
    pages.push({
      kind: 'gel-service',
      sectionEyebrow: GEL_SECTION,
      service,
      imageSrc: src,
      imageAlt: alt,
    })
  }

  pages.push({ kind: 'section', title: PED_SECTION })
  for (const service of pedicureServices) {
    const imageKey = service.imageKey ?? service.id
    const { src, alt } = getPrintMenuImage(imageKey)
    pages.push({
      kind: 'service',
      sectionEyebrow: PED_SECTION,
      service,
      imageSrc: src,
      imageAlt: alt,
    })
  }

  pages.push({
    kind: 'additional-services',
    addOnServices: sorted.filter((service) => service.category === 'addOn'),
  })
  pages.push({ kind: 'back' })

  return pages
}
